import { Request } from '../../Servidor/Request';

export class LocalityCategoryRequest {
    private sgepcategorialocalidade: number;
    private nome: string;
    private codigo: string

    constructor(sgepcategorialocalidade: number, nome: string, codigo: string) {
        this.sgepcategorialocalidade = sgepcategorialocalidade;
        this.nome = nome;
        this.codigo = codigo;
    }


    /**
     * Getter sgepcategorialocalidade
     * @return {number}
     */
    public getSgepcategoriaLocalidade(): number {
        return this.sgepcategorialocalidade;
    }

    /**
     * Getter nome
     * @return {string}
     */
    public getNome(): string {
        return this.nome;
    }
    /**
    * Getter codigo
    * @return {string}
    */
    public getCodigo(): string {
        return this.codigo;
    }
}

export class LocalityCategoryStructRequest {
    private sgepcategorialocalidade: number;

    constructor(sgepcategorialocalidade: number) {
        this.sgepcategorialocalidade = sgepcategorialocalidade;
    }


    /**
     * Getter sgepcategorialocalidade
     * @return {number}
     */
    public getSgepcategoriaLocalidade(): number {
        return this.sgepcategorialocalidade;
    }

}

export class LocalityCategoryStructResponse {
    private sgepcategorialocalidade: number;
    private nome: string;

    constructor(sgepcategorialocalidade: number, nome: string) {
        this.sgepcategorialocalidade = sgepcategorialocalidade;
        this.nome = nome;
    }


    /**
     * Getter sgepcategorialocalidade
     * @return {number}
     */
    public getSgepcategoriaLocalidade(): number {
        return this.sgepcategorialocalidade;
    }

    /**
     * Getter nome
     * @return {string}
     */
    public getNome(): string {
        return this.nome;
    }
}

export class LocalityCategoryInteractor {
    public fetchSave(request: LocalityCategoryRequest): PromiseLike<Boolean> {
        return new Promise((res, rej) => {
            return new Request().requestPost("dengue/categoria-localidade/salvar", request).then((rs) => {
                if (rs == undefined) {
                    return rej({
                        Mensagem: "Erro ao conectar"
                    })
                }

                let response = rs.Status == "Sucesso"
                res(response)
            }, e => {
                rej(e);
            });
        });
    }

    public fetchDataOne(request: LocalityCategoryStructRequest): PromiseLike<LocalityCategoryStructResponse> {
        return new Promise((res, rej) => {
            return new Request().requestPost("dengue/categoria-localidade/buscar", request).then((rs) => {
                if (rs == undefined) {
                    return rej({
                        Mensagem: "Erro ao conectar"
                    })
                }

                res(rs.Resultado)
            }, e => {
                rej(e);
            });
        });
    }
}